const apiClient = async (endpoint, options = {}) => {
  const config = {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  }

  const response = await fetch(endpoint, config)

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.error || `API request failed with status ${response.status}`)
  }

  return response.json()
}

export const apiGet = (endpoint) => apiClient(endpoint, { method: 'GET' })

export const apiPost = (endpoint, body) =>
  apiClient(endpoint, { method: 'POST', body: JSON.stringify(body) })

export const apiPut = (endpoint, body) =>
  apiClient(endpoint, { method: 'PUT', body: JSON.stringify(body) })

export const apiDelete = (endpoint) => apiClient(endpoint, { method: 'DELETE' })

export default apiClient
